export default __webpack_public_path__ + "static/media/Aura-Egg__87.5af0a2ca.png";